import { createFileRoute } from '@tanstack/react-router'
import { RequirePermission } from '@/components/ui/require-permission'
import CustomerNewPage from '@/features/customers/customer-new'

export const Route = createFileRoute('/_authenticated/customers/new')({
  component: () => (
    <RequirePermission permission='customers.create'>
      <CustomerNewPage />
    </RequirePermission>
  ),
})
